import React from "react";
import { LuChevronDown } from "react-icons/lu";
import usePersistentToggle from "../../../shared/hooks/usePersistentToggle";
import "./SalesDashboardSection.css";

/**
 * Bloco recolhível com o "dashboard" da tela de Vendas (indicadores,
 * gráficos, mais vendidos). Fechado, sobra a tela pra lista de pedidos.
 * Aberto/fechado é lembrado no navegador.
 */
const SalesDashboardSection = ({ children }) => {
  const { value: open, toggle } = usePersistentToggle(
    "svelta-admin:sales-dashboard-open",
    true,
  );

  return (
    <section className={`sales-dashboard ${open ? "is-open" : "is-closed"}`}>
      <button
        type="button"
        className="sales-dashboard__toggle"
        onClick={toggle}
        aria-expanded={open}
        aria-controls="sales-dashboard-content"
      >
        <span className="sales-dashboard__title">Resumo de vendas</span>
        <span className="sales-dashboard__hint">
          {open ? "Recolher" : "Mostrar indicadores e gráficos"}
        </span>
        <LuChevronDown size={18} className="sales-dashboard__chevron" />
      </button>

      {open && (
        <div id="sales-dashboard-content" className="sales-dashboard__content">
          {children}
        </div>
      )}
    </section>
  );
};

export default SalesDashboardSection;
